<template>
  <div>
    <div class="d-flex justify-space-between">
      <div class="flex flex-col lg:flex-row lg:items-center">
        <text-field-label
          label="ขนส่ง Shopee Xpress"
          class="mr-6">
        </text-field-label>
        <v-chip
          v-if="!expand"
          color="warning"
          class="chip-warning lg:self-center self-start"
          small
          label
          outlined>
          New
        </v-chip>
      </div>
      <div class="flex lg:flex-row flex-col lg:items-center items-end justify-end gap-1">
        <v-chip
          v-if="shippingId && shippingSecret"
          class="chip-success"
          color="success"
          outlined>
          <v-icon
            left
            small>
            mdi-check-circle
          </v-icon>
          เปิดใช้งาน
        </v-chip>
        <v-chip
          v-else
          class="chip-error"
          color="error"
          outlined>
          <v-icon
            left
            small>
            mdi-close-circle
          </v-icon>
          ยังไม่เปิดใช้งาน
        </v-chip>
        <v-btn
          color="primary"
          text
          rounded
          @click="expand = !expand">
          <text-field-label
            v-if="expand"
            label="ยกเลิก"
            style="color: var(--v-primary-base) !important;"
            class="mt-2">
          </text-field-label>
          <text-field-label
            v-else
            label="แก้ไข"
            style="color: var(--v-primary-base) !important;"
            class="mt-2">
          </text-field-label>
        </v-btn>
      </div>
    </div>
    <v-expand-transition>
      <div v-if="expand">
        <v-row
          class="pl-12 mt-4 mb-4"
          no-gutters>
          <v-col
            cols="4"
            class="pl-8">
            <text-field-label label="การเข้ารับ">
            </text-field-label>
          </v-col>
          <v-col>
            <select-form
              v-model="form.shopeeExpressPickup"
              :items="shopeeExpressPickupSelectableItem"
              item-value="value"
              item-text="text"
              :attach="true"
              style="max-width: 300px;"
              @input="submit('shopeeExpressPickup')">
            </select-form>
          </v-col>
        </v-row>
        <v-row
          class="pl-12 mt-4 mb-4"
          no-gutters>
          <v-col
            cols="4"
            class="pl-8">
            <text-field-label label="User id">
            </text-field-label>
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.shopeeExpressId"
              style="max-width: 300px;"
              hide-details
              autofocus
              outlined
              dense
              @input="debounceValidToken($event)">
              <template #append>
                <v-fade-transition>
                  <div class="mt-1">
                    <v-img
                      v-if="validShipingId"
                      :src="getIcon(validShipingId)"
                      height="16"
                      eager
                      contain />
                  </div>
                </v-fade-transition>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="pl-12 mt-4 mb-4"
          no-gutters>
          <v-col
            cols="4"
            class="pl-8">
            <text-field-label label="User secret ">
            </text-field-label>
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.shopeeExpressSecret"
              style="max-width: 300px;"
              hide-details
              outlined
              dense
              @input="debounceValidToken($event)">
              <template #append>
                <v-fade-transition>
                  <div class="mt-1">
                    <v-img
                      v-if="validShipingSecret"
                      :src="getIcon(validShipingSecret)"
                      height="16"
                      eager
                      contain />
                  </div>
                </v-fade-transition>
              </template>
            </v-text-field>
            <save-change-button
              class="mt-3"
              :disabled="!valid"
              :state="state"
              :label="$t('shipping.btn.save')"
              @click="submit()">
            </save-change-button>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import { SHOPEE_XPRESS_VALID_TOKEN, UPDATE_SETTING } from '@/resources/graphql'

export default {
  props: {
    shippingId: {
      type: [String, Number],
      default: ''
    },
    shippingSecret: {
      type: String,
      default: ''
    },
    shopeeExpressPickup: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      expand: false,
      state: 'ready',
      validShipingId: null,
      validShipingSecret: null,
      form: {
        shopeeExpressId: '',
        shopeeExpressSecret: '',
        shopeeExpressPickup: true
      },
      shopeeExpressPickupSelectableItem: [
        {
          value: true,
          text: 'ขนส่งเข้ารับสินค้า (Pickup)'
        },
        {
          value: false,
          text: 'นำส่งที่สาขา (Dropoff)'
        }
      ]
    }
  },
  computed: {
    loading () {
      return this.state === 'loading'
    },
    valid () {
      return (!this.form.shopeeExpressId && !this.form.shopeeExpressSecret)
        || (this.validShipingId === 'success' && this.validShipingSecret === 'success')
    }
  },
  watch: {
    shippingId (newValue) {
      this.form.shopeeExpressId = newValue
    },
    shippingSecret (newValue) {
      this.form.shopeeExpressSecret = newValue
    },
    shopeeExpressPickup (newValue) {
      this.form.shopeeExpressPickup = newValue
    },
    expand (newValue) {
      if (newValue) {
        this.validShipingId = ''
        this.validShipingSecret = ''
        this.form.shopeeExpressId = this.shippingId
        this.form.shopeeExpressSecret = this.shippingSecret
        this.form.shopeeExpressPickup = this.shopeeExpressPickup
      }
    }
  },
  created () {
    this.debounceValidToken = this.$_.debounce(this.validToken, 800)
  },
  methods: {
    getIcon (state) {
      switch (state) {
      case 'success':
        return `${process.env.VUE_APP_ROUTE_PREFIX}imgs/icon/correct_icon.gif?fid=${ Math.random(10000) }`
      case 'error':
        return `${process.env.VUE_APP_ROUTE_PREFIX}imgs/icon/incorrect_icon.gif?fid=${ Math.random(10000) }`
      default: return null
      }
    },
    async validToken () {
      const shippingId = this.form.shopeeExpressId
      const shipingSecret = this.form.shopeeExpressSecret
      if (!shippingId && !shipingSecret) {
        this.validShipingId = ''
        this.validShipingSecret = ''
        return
      }

      if (!shippingId || !shipingSecret) return
      const { data: { shopeeExpressCheckInput: { success } } } = await this.$apollo.mutate({
        mutation: SHOPEE_XPRESS_VALID_TOKEN,
        variables: {
          input: {
            shopeeExpressId: shippingId,
            shopeeExpressSecret: shipingSecret
          }
        }
      })
      if (success) {
        this.validShipingId = 'success'
        this.validShipingSecret = 'success'
      } else {
        this.validShipingId = 'error'
        this.validShipingSecret = 'error'
      }
    },
    async submit () {
      this.state = 'loading'
      const { data: { updateSetting } } = await this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            shopeeExpressId: this.form.shopeeExpressId,
            shopeeExpressSecret: this.form.shopeeExpressSecret,
            shopeeExpressPickup: this.form.shopeeExpressPickup
          }
        }
      }).catch(() => {
        this.state = 'error'
      })
      if (updateSetting) {
        this.$emit('update:shipping-id', updateSetting.setting.shopeeExpressId)
        this.$emit('update:shipping-secret', updateSetting.setting.shopeeExpressSecret)
        this.$emit('update:shopee-express-pickup', updateSetting.setting.shopeeExpressPickup)
        this.state = 'success'
      }
      setTimeout(() => {
        this.state = 'ready'
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-chip.v-chip--outlined {
  &.chip-success {
    background-color: #e9ffec !important;
  }
  &.chip-error {
    background-color: #feeae6 !important;
  }
  &.chip-warning {
    background-color: #FFF4DE !important;
  }
}
</style>
